// extracted by mini-css-extract-plugin
export default {"slideContainer":"d9eaea6d61 _35ad1e636d bc2eab6928","slideImage":"dc99d93af7"};